import { RecruitJobDetailType } from 'features/recruitment/jobs/components/types';
import CandidatesBoard from './CandidateBoard';
import { isInterviewer } from 'features/recruitment/jobs/components/types';
import ListCandidate from './ListCandidate';
import { useState } from 'react';
import CustomButton from 'styles/buttonStyled';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import AddCandidatesModal from './AddCandidatesModal';

const Candidates = ({
  reload,
  data,
  handleChange,
}: {
  reload?: () => void;
  data?: RecruitJobDetailType;
  handleChange: (value: any) => void;
}) => {
  const { t } = useTranslation(['recruitment']);
  const [visible, setVisible] = useState(false);

  if (isInterviewer()) return <ListCandidate data={data} />;

  return (
    <>
      <Toolbar>
        <CustomButton onClick={() => setVisible(true)}>
          {t('recruitment:candidate_pool_add_button')}
        </CustomButton>
      </Toolbar>
      <CandidatesBoard reload={reload} data={data} handleChange={handleChange} />
      <AddCandidatesModal
        visible={visible}
        jobId={data?.id}
        onCancel={() => setVisible(false)}
        onAdded={() => {
          setVisible(false);
          reload && reload();
        }}
      />
    </>
  );
};

const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 10px 12px;
`;

export default Candidates;
